import { FormikContext as fe } from "formik";
import { createContext as Gt, useMemo as U, useCallback as P, useReducer as ue, useContext as le, useState as j, useEffect as tt } from "react";
import { dateFromString as $, formatDate as ut, toHumanDate as q } from "../../utils/date.es.js";
import { c as Ut } from "../../index-226b8ea6.js";
import { d as De, h as de, i as me, l as ge } from "../../floating-ui.react-5e63cf1f.js";
import { INPUT_VALUE_FORMAT as lt } from "./DatePicker.constants.es.js";
import { getInitialOffset as he, getInitialValue as et, getOffsetDate as _t } from "./DatePicker.utils.es.js";
import { i as nt } from "../../isEqual-24663bfb.js";
import { b as Ee, f as ye, o as Ae, s as Se } from "../../floating-ui.dom-55cf142e.js";
const O = (t, e, ...n) => !t || e == null ? /* @__PURE__ */ new Date() : new Date(t, e, ...n), T = (t) => ({
  D: t.getDate(),
  M: t.getMonth(),
  Y: t.getFullYear()
}), Te = (t) => t.getDay(), x = (t) => O(T(t).Y, T(t).M, T(t).D), dt = (t) => O(T(t).Y, T(t).M + 1, 0).getDate(), X = (t, e, n) => {
  const { Y: s, M: r, D: i } = T(t), f = n === "date" ? i + e : n === "month" && i > dt(O(s, r + e, 1)) ? dt(O(s, r + e, 1)) : i;
  return O(s + (n === "year" ? e : 0), r + (n === "month" ? e : 0), f);
}, bt = (t, e, n) => X(t, 0 - e, n), kt = (t, e) => +t - +e, Q = (t, e, n) => t.toLocaleDateString(e, n), Ht = (t, { locale: e, monthName: n }) => Q(t, e, { month: n }), Me = (t, { locale: e, options: n }) => Q(t, e, n), Nt = (t, e, n, s) => s && s.h != null && s.m != null ? O(t, e, n, s.h, s.m) : void 0, _e = (t, { locale: e, hour: n, minute: s, second: r, hour12: i }) => t.toLocaleTimeString(e, {
  hour: n,
  minute: s,
  second: r,
  hour12: i
}), st = (t) => `${t < 10 ? 0 : ""}${t}`, be = (t, e) => {
  const n = t >= 12 ? "pm" : "am";
  return `${st(t % 12 || 12)}:${st(e)} ${n}`;
}, Ne = (t, { hour12: e }) => {
  const n = t.getHours(), s = t.getMinutes();
  return e ? be(n, s) : `${st(n)}:${st(s)}`;
}, Ot = (t, e) => t.concat(e).sort(kt), Yt = (t, e, n) => {
  let [s, r] = [t, e];
  return t && e && ([s, r] = [t, e].sort(n)), [s, r];
}, Oe = (t, e) => e ? e.includes(t) : !1, Ye = (t, e = []) => {
  const { M: n, D: s } = T(t);
  return e.some((r) => {
    const { M: i, D: f } = T(r);
    return n === i && s === f;
  });
}, Ie = (t, { day: e, date: n } = {}) => Oe(t.getDay(), e) || Ye(t, n);
var ve = 42;
function It(t, e) {
  return (Te(t) + 7 - e) % 7;
}
function xe(t, e, { mode: n, startDay: s }) {
  const r = O(e, t, 1), i = dt(r), f = It(r, s), u = n === "static" ? ve : f + i + 6 - It(O(e, t, i), s);
  return {
    start: f,
    length: u
  };
}
const F = (t, e) => +t == +e, rt = (t, e) => t < e, mt = (t, e) => t > e, vt = (t, e, n) => mt(e, t) && rt(e, n) || rt(e, t) && mt(e, n), k = (t, e) => !!t && mt(e, t), H = (t, e) => !!t && rt(e, t), at = (t, e) => t.some((n) => F(x(n), x(e))), Pe = (t, e) => !!e && t < T(e).M, Fe = (t, e) => !!e && t < T(e).Y, pe = (t, e) => !!e && t > T(e).M, Le = (t, e) => !!e && t > T(e).Y, we = (t, e) => !!e && t >= T(e).Y, Ce = (t, e) => !!e && t <= T(e).Y;
var xt = {
  mode: "static",
  offsets: [0],
  startDay: 0
}, $e = {
  mode: "decade",
  /*
   * The default value for the numberOfYears is 12
   * it consists of 10 years + 1 year before + 1 year after
   */
  numberOfYears: 12,
  step: 10
}, Re = {
  mode: "single",
  toggle: !1,
  selectSameDate: !1
}, Be = {
  interval: 30,
  useLocales: !1
}, Ge = {
  locale: "en-GB",
  day: "2-digit",
  year: "numeric",
  weekday: "short",
  monthName: "long",
  hour: "2-digit",
  minute: "2-digit",
  hour12: void 0,
  second: void 0
};
function Ue({ selectedDates: t = [], onDatesChange: e, focusDate: n, offsetDate: s, onOffsetChange: r, calendar: i = {}, dates: f = {}, locale: u, time: l = {}, exclude: g = {}, years: m }) {
  const { minDate: h, maxDate: o, ...E } = f, { offsets: M = [], ...y } = i, { minTime: D, maxTime: Y, ...A } = l, [d, I] = Yt(h, o, kt), [_, Z] = Yt(D, Y, (ot, it) => ot.h - it.h), L = n && at(t, n) ? n : void 0;
  return {
    selectedDates: t,
    onDatesChange: e,
    offsetDate: s,
    onOffsetChange: r,
    focusDate: L,
    calendar: {
      ...xt,
      ...y,
      offsets: xt.offsets.concat(M)
    },
    years: { ...$e, ...m },
    dates: {
      ...Re,
      ...E,
      minDate: d && x(d),
      maxDate: I && x(I)
    },
    locale: {
      ...Ge,
      ...u
    },
    time: {
      ...Be,
      minTime: _,
      maxTime: Z,
      ...A
    },
    exclude: g
  };
}
function J(t) {
  return t === "range";
}
const Pt = "range-start", Ft = "range-end", pt = "will-be-range-start", Lt = "will-be-range-end", ke = (t, e, n, s) => {
  if (!J(s) || n.length === 0)
    return "";
  const [r, i] = n;
  return r && i ? F(t, x(r)) ? F(x(r), x(i)) ? `${Pt} ${Ft}` : Pt : F(t, x(i)) ? Ft : vt(x(r), t, x(i)) ? "in-range" : "" : !i && e ? vt(x(r), t, e) ? "will-be-in-range" : rt(e, x(r)) ? F(t, e) ? pt : F(t, x(r)) ? Lt : "" : F(t, x(r)) ? pt : F(t, e) ? Lt : "" : "";
}, He = (t, e, n, { rangeEnd: s }, r) => {
  const { dates: { mode: i, minDate: f, maxDate: u }, locale: l, calendar: g, exclude: m } = r, { locale: h, day: o, year: E } = l, { M, Y: y } = T(e), { start: D, length: Y } = xe(M, y, g), A = Array(Y).fill(0).map((d, I) => {
    const _ = O(y, M, I + 1 - D);
    return {
      $date: _,
      active: F(t, _),
      day: Q(_, h, { day: o }),
      now: F(x(O()), _),
      range: ke(_, s, n, i),
      disabled: H(f, _) || k(u, _) || Ie(_, m),
      selected: at(n, _),
      inCurrentMonth: T(_).M === M
    };
  });
  return {
    year: Q(e, h, { year: E }),
    month: Ht(e, l),
    days: A
  };
}, We = ({ selectedDates: t, state: e, config: n, offsetDate: s }) => n.calendar.offsets.map((r) => He(s, X(s, r, "month"), t, e, n));
var je = ({ days: t }, { locale: { locale: e, weekday: n } }) => [0, 1, 2, 3, 4, 5, 6].map((s) => Q(t[s].$date, e, { weekday: n }));
const qe = (t) => {
  const e = We(t);
  return U(() => ({
    calendars: e,
    weekDays: je(e[0], t.config)
  }), [e, t.config]);
}, R = (...t) => (...e) => t.forEach((n) => n == null ? void 0 : n(...e)), G = (t) => (e, n) => t(n), wt = (t) => (...e) => {
  t();
}, B = (t, e, n = {}, s = !1) => ({
  role: "button",
  tabIndex: 0,
  ...t ? {
    disabled: !0,
    "aria-disabled": !0
  } : {
    onClick(r) {
      e(r);
    }
  },
  ...s ? { "aria-selected": !0 } : {},
  ...n
});
var Wt = "SET_FOCUS_DATE", jt = "SET_OFFSET_DATE", qt = "SET_RANGE_END", Xt = "SET_YEAR", Xe = (t, e) => {
  switch (e.type) {
    case Wt:
      return {
        ...t,
        focusDate: e.date
      };
    case jt:
      return {
        ...t,
        offsetDate: e.date
      };
    case qt:
      return {
        ...t,
        rangeEnd: e.date
      };
    case Xt:
      return {
        ...t,
        offsetYear: e.year
      };
    default:
      return t;
  }
}, gt = (t, e) => {
  t({ type: Wt, date: e });
}, Ze = (t, e) => {
  t({ type: jt, date: e });
}, Ct = (t, e) => {
  t({ type: qt, date: e });
}, $t = (t, e) => {
  t({ type: Xt, year: e });
};
const K = ({ dispatch: t, config: { onOffsetChange: e, offsetDate: n } }) => (s) => {
  !e && !n && Ze(t, s), e && e(s);
}, Rt = (t, { days: e, months: n, years: s }) => {
  let r = t;
  return e && e !== 0 && (r = X(r, e, "date")), n && n !== 0 && (r = X(r, n, "month")), s && s !== 0 && (r = X(r, s, "year")), r;
}, Bt = (t, { days: e = 0, months: n = 0, years: s = 0 }, r) => !r || F(t, r) ? t : e !== 0 ? Dt(t, r, e, "date") : n !== 0 ? Dt(t, r, n, "month") : s !== 0 ? Dt(t, r, s, "year") : t, Dt = (t, e, n, s) => {
  const r = X(t, n, s);
  return n > 0 ? k(e, r) ? bt(e, n, s) : t : H(e, r) ? bt(e, n, s) : t;
}, ze = (t) => {
  const { config: { dates: e } } = t, { minDate: n, maxDate: s } = e, r = P((u, { disabled: l, onClick: g, ...m } = {}) => {
    const h = Bt(t.offsetDate, u, s), o = Rt(h, u), E = !!l || k(s, o);
    return B(E, (M) => R(g, G(K(t)))(M, o), m);
  }, [s, t]), i = P(({ days: u = 0, months: l = 0, years: g = 0 }, { disabled: m, onClick: h, ...o } = {}) => {
    const E = {
      days: -u,
      months: -l,
      years: -g
    }, M = Bt(t.offsetDate, E, n), y = Rt(M, E), D = !!m || H(n, y);
    return B(D, (Y) => R(h, G(K(t)))(Y, y), o);
  }, [n, t]), f = P((u, { disabled: l, onClick: g, ...m } = {}) => {
    const h = !!l || H(n, u) || k(s, u);
    return B(h, (o) => R(g, G(K(t)))(o, u), m);
  }, [t, s, n]);
  return {
    addOffset: r,
    setOffset: f,
    subtractOffset: i
  };
}, Je = (t, e, n) => k(e, n) ? e : H(t, n) ? t : n, Ke = (t) => t - t % 10 - 1, Qe = (t, e) => t - (e / 2 - (e % 2 === 0 ? 1 : 0)), Ve = (t, e) => t - e + 1, Zt = (t) => t === "exact", tn = (t, { mode: e, numberOfYears: n }) => Zt(e) ? Ve(t, n) : e === "decade" ? Ke(t) : Qe(t, n), en = (t) => {
  const { selectedDates: e, offsetDate: n, focusDate: s, dates: { minDate: r, maxDate: i }, years: f } = t, u = n || (e.length > 0 ? e[e.length - 1] : Je(r, i, x(O())));
  return {
    focusDate: s,
    rangeEnd: null,
    offsetDate: u,
    offsetYear: tn(T(u).Y, f)
  };
}, nn = (t) => {
  const e = Ue(t), [n, s] = ue(Xe, en(e));
  return {
    dispatch: s,
    selectedDates: e.selectedDates,
    offsetDate: e.offsetDate || n.offsetDate,
    state: n,
    config: e
  };
}, sn = (t, e, { mode: n, toggle: s, limit: r }) => s && at(t, e) ? t.filter((i) => !F(x(i), e)) : n === "multiple" ? !r || t.length < r ? Ot(t, e) : t : J(n) ? t.length === 2 ? [e] : Ot(t, e) : [e], rn = ({ selectedDates: t, config: { locale: e } }) => U(() => ({
  selectedDates: t,
  formattedDates: t.map((n) => Me(n, e))
}), [t, e]), an = ({ config: t, selectedDates: e, dispatch: n }) => {
  const { onDatesChange: s, dates: { mode: r, toggle: i, selectSameDate: f } } = t;
  return { dayButton: P(({ $date: l, selected: g, disabled: m, active: h }, { onClick: o, disabled: E, ...M } = {}) => B(m || !!E, (y) => {
    g && !i && (e.forEach((D) => {
      F(x(D), l) && gt(n, D);
    }), !J(r) || !f) || (J(r) && e.length === 1 && Ct(n, null), R(o, G((D) => {
      const Y = sn(e, D, t.dates);
      gt(n, at(Y, D) ? D : void 0), s(Y);
    }))(y, l));
  }, {
    ...M,
    ...J(r) && e.length === 1 && {
      onMouseEnter() {
        Ct(n, l);
      }
    },
    tabIndex: h ? 0 : -1
  }, g), [
    r,
    i,
    t.dates,
    s,
    e,
    n,
    f
  ]) };
};
var on = (t, e, n, { minDate: s, maxDate: r }) => {
  const { M: i, Y: f } = T(t), { Y: u, M: l } = T(O());
  return Array(12).fill(0).map((g, m) => {
    const h = O(f, m, 1);
    return {
      $date: h,
      month: Ht(h, n),
      selected: e.some((o) => {
        const { M: E, Y: M } = T(o);
        return M === f && E === m;
      }),
      active: i === m,
      now: m === l && f === u,
      disabled: Pe(m, s) && Ce(f, s) || pe(m, r) && we(f, r)
    };
  });
};
const cn = ({ selectedDates: t, offsetDate: e, config: { locale: n, dates: s } }) => U(() => ({
  months: on(e, t, n, s)
}), [s, n, e, t]), fn = (t) => ({ monthButton: P(({ $date: n, disabled: s, selected: r, active: i }, { onClick: f, disabled: u, ...l } = {}) => B(!!u || s, (g) => R(f, G(K(t)))(g, n), {
  ...l,
  tabIndex: i ? 0 : -1
}, r), [t]) });
var un = (t, { time: e, locale: n }) => {
  const s = O(), { interval: r, minTime: i, maxTime: f, useLocales: u } = e, { Y: l, M: g, D: m } = T(t || s), h = 1440 / r, o = Nt(l, g, m, i), E = Nt(l, g, m, f);
  return Array(h).fill(0).map((M, y) => {
    const D = O(l, g, m, 0, y * r), Y = !t || H(o, D) || k(E, D);
    return {
      $date: D,
      disabled: Y,
      now: F(D, s),
      selected: t ? F(t, D) : !1,
      time: u ? _e(D, n) : Ne(D, n)
    };
  });
};
const ln = ({ state: { focusDate: t }, config: e }) => U(() => ({
  time: un(t, e)
}), [t, e]), Dn = ({ selectedDates: t, state: { focusDate: e }, config: { onDatesChange: n }, dispatch: s }) => ({ timeButton: P(({ $date: i, selected: f, disabled: u, now: l }, { onClick: g, disabled: m, ...h } = {}) => B(u || !!m, (o) => {
  f || R(g, G((E) => {
    const M = t.map((y) => F(e, y) ? E : y);
    gt(s, E), n(M);
  }))(o, i);
}, {
  ...h,
  tabIndex: f || l ? 0 : -1
}, f), [t, n, s, e]) }), dn = (t, e, n, { numberOfYears: s }, { minDate: r, maxDate: i }) => {
  const { Y: f, M: u, D: l } = T(e), { Y: g } = T(O());
  return Array(s).fill(0).map((m, h) => {
    const o = t + h;
    return {
      $date: O(o, u, l),
      active: f === o,
      disabled: Fe(o, r) || Le(o, i),
      now: o === g,
      selected: n.some((M) => T(M).Y === o),
      year: o
    };
  });
}, mn = ({ selectedDates: t, state: { offsetDate: e, offsetYear: n }, config: { years: s, dates: r } }) => U(() => ({
  years: dn(n, e, t, s, r)
}), [e, n, t, s, r]), gn = (t) => {
  const { state: { offsetYear: e, offsetDate: n }, config: { dates: s, years: r }, dispatch: i } = t, { minDate: f, maxDate: u } = s, { step: l, numberOfYears: g, mode: m } = r, { D: h, M: o } = T(n), E = P(({ $date: D, disabled: Y, selected: A, active: d }, { onClick: I, disabled: _, ...Z } = {}) => B(!!_ || Y, (L) => R(I, G(K(t)))(L, D), {
    ...Z,
    tabIndex: d ? 0 : -1
  }, A), [t]), M = P(({ onClick: D, disabled: Y, ...A } = {}) => {
    const d = O(e + g - 1, o, h), I = !!Y || k(u, d) || Zt(m) && !!u && F(u, d);
    return B(I, (_) => R(D, wt(() => $t(i, e + l)))(_), A);
  }, [u, i, e, l, h, o, g, m]), y = P(({ onClick: D, disabled: Y, ...A } = {}) => {
    const d = !!Y || H(f, O(e, o, h));
    return B(d, (I) => R(D, wt(() => $t(i, e - l)))(I), A);
  }, [f, i, e, l, o, h]);
  return {
    yearButton: E,
    nextYearsButton: M,
    previousYearsButton: y
  };
}, hn = (t) => {
  const e = nn(t);
  return {
    data: {
      ...qe(e),
      ...rn(e),
      ...cn(e),
      ...ln(e),
      ...mn(e)
    },
    propGetters: {
      ...an(e),
      ...fn(e),
      ...Dn(e),
      ...gn(e),
      ...ze(e)
    }
  };
};
Gt({});
Gt({});
const On = ({
  closeOnSelect: t = !1,
  dataTestId: e,
  debounceDelay: n = 150,
  defaultIsOpen: s,
  errors: r = {},
  isError: i,
  isLoading: f,
  isSmartData: u = !1,
  max: l,
  maxYears: g = (/* @__PURE__ */ new Date()).getFullYear() + 6,
  min: m,
  minYears: h = 1900,
  mode: o = "single",
  onChange: E,
  onRetry: M,
  validate: y,
  value: D,
  inputProps: Y,
  ...A
}) => {
  const d = le(fe), [I, _] = j({
    year: !1,
    month: !1,
    day: !1
  }), Z = U(() => "label" in A && A.label ? [A.label] : "startLabel" in A && A.startLabel && "endLabel" in A && A.endLabel ? [A.startLabel, A.endLabel] : [], [o]), L = U(() => {
    if (o === "single")
      return ["name" in A && A.name ? A.name : "date"];
    if (o === "range") {
      const a = "startName" in A && A.startName ? A.startName : "startDate", c = "endName" in A && A.endName ? A.endName : "endDate";
      return [a, c];
    }
    return [];
  }, [o]), [ot, it] = j(r), [ht, Et] = j(s ?? !1), [ct, W] = j(he(o, D)), [v, p] = j(et(o, D)), [V, yt] = j(!1), w = $(`${h}-1-1`), C = $(`${g}-12-31`), At = (a) => {
    Et(a), _({ year: !1, month: !1, day: !1 });
  }, { refs: zt, floatingStyles: Jt, context: ft } = De({
    whileElementsMounted: Ee,
    open: ht,
    onOpenChange: At,
    placement: "bottom-start",
    middleware: [ye(), Ae(10), Se()]
  }), Kt = de(ft, { role: "dialog" }), Qt = me(ft, { bubbles: !0 }), { getReferenceProps: Vt, getFloatingProps: te } = ge([Kt, Qt]), ee = hn({
    calendar: { startDay: 1 },
    years: { mode: "fluid", numberOfYears: 250 },
    dates: { mode: o, minDate: m ?? w, maxDate: l ?? C },
    offsetDate: ct,
    onDatesChange: p,
    onOffsetChange: W,
    selectedDates: v
  }), St = P(
    (a) => {
      const c = $(a);
      if (c) {
        const S = _t(c, w, C);
        W(S);
      }
    },
    [W]
  ), Tt = P(
    (a) => {
      if (!a.length) {
        p([]);
        return;
      }
      let c = [];
      const [, S] = v, N = $(a);
      N && c.push(N), c.length && S && c.push(S), p(c);
    },
    [p, v]
  ), ne = (a, c = !1) => {
    St(a), c && Tt(a);
  }, se = P(
    (a) => {
      const c = $(a);
      if (c) {
        const S = _t(c, w, C);
        W(S);
      }
    },
    [ct, p]
  ), re = P(
    (a) => {
      if (!a.length) {
        const [b] = v;
        p(b ? [b] : []);
        return;
      }
      let c = [];
      const [S] = v, N = $(a);
      S && c.push(S), c.length && N && c.push(N), p(c);
    },
    [v, p]
  ), ae = P(() => {
    if (o === "single") {
      const [a] = v, [c] = et(o, D);
      (!nt(c, a) || V) && (E == null || E({ date: a, dateIso: a == null ? void 0 : a.toISOString() }), d == null || d.setFieldValue(L[0], ut(a, lt)));
    }
    if (o === "range") {
      const [a, c] = v, [S, N] = et(o, D);
      (!nt(a, S) || !nt(c, N)) && (E == null || E({
        endDate: c,
        endDateIso: c == null ? void 0 : c.toISOString(),
        startDate: a,
        startDateIso: a == null ? void 0 : a.toISOString()
      }), d == null || d.setFieldValue(
        L[0],
        a ? ut(a, lt) : void 0
      ), d == null || d.setFieldValue(
        L[1],
        c ? ut(c, lt) : void 0
      ));
    }
  }, [E, v, V]), oe = P(
    (a = !1) => {
      const [c] = v;
      p(a && c ? [c] : []), yt(!0), _({ year: !1, month: !1, day: !1 });
    },
    [v]
  ), ie = P(
    (a) => {
      _({ ...I, ...a });
    },
    [I, _]
  ), ce = P(() => {
    const [a, c] = L, [S, N] = v, b = {};
    if (o === "single" && (S < w && (b[a] = `Date is too early, minimum date is ${q(w)}`), S > C && (b[a] = `Date is too late, maximum date is ${q(C)}`), y)) {
      const z = y == null ? void 0 : y({ dates: v })[a];
      z && (b[a] = z);
    }
    if (o === "range" && (S < w && (b[a] = `Date is too early, minimum date is ${q(w)}`), S > C && (b[a] = `Date is too late, maximum date is ${q(C)}`), N < w && (b[c] = `Date is too early, minimum date is ${q(w)}`), N > C && (b[c] = `Date is too late, maximum date is ${q(C)}`), S > N && (b[a] = "Start date is after end date", b[c] = "End date is before start date"), y)) {
      const z = y == null ? void 0 : y({ dates: v })[a], Mt = y == null ? void 0 : y({ dates: v })[c];
      z && (b[a] = z), Mt && (b[a] = Mt);
    }
    return it(b), d == null || d.setErrors(b), b;
  }, [v]);
  return tt(() => {
    const a = ce();
    (!Object.keys(a).length || V) && (ae(), yt(!1));
  }, [v, V]), tt(() => {
    const a = et(o, D);
    nt(a, v) || p(a);
  }, [D, L]), tt(() => {
    const a = d == null ? void 0 : d.values[L[0]], c = d == null ? void 0 : d.values[L[1]];
    if (o === "single") {
      let S = [];
      const N = a ? $(a) : void 0;
      N && S.push(N), p(S), W(S.length ? S[0] : /* @__PURE__ */ new Date());
    }
    if (o === "range") {
      let S = [];
      const N = a && $(a), b = c && $(c);
      N && S.push(N), b && S.push(b), p(S), N && W(N);
    }
  }, [d == null ? void 0 : d.values]), tt(() => {
    t && I.day && I.month && I.year && At(!1);
  }, [t, I]), {
    ...ee,
    closeOnSelect: t,
    customErrors: r,
    dataTestId: e,
    debounceDelay: n,
    dirty: I,
    errors: ot,
    floatingContext: ft,
    floatingStyles: Jt,
    formikContext: d,
    getFloatingProps: te,
    getReferenceProps: Vt,
    inputProps: Y,
    isError: i,
    isLoading: f,
    isOpen: ht,
    isSmartData: u,
    labels: Z,
    maxInputDate: C,
    maxYears: g,
    minInputDate: w,
    minYears: h,
    mode: o,
    names: L,
    offsetDate: ct,
    onClear: oe,
    onEndDateChange: se,
    onEndDateEnter: re,
    onRetry: M,
    onStartDateChange: St,
    onStartDateEnter: Tt,
    refs: zt,
    setIsOpen: Et,
    updateDate: ne,
    updateDirty: ie
  };
}, [Yn, In] = Ut(), [vn, xn] = Ut({
  name: "DatePickerStylesContext",
  errorMessage: `useDatePickerStyles returned is 'undefined'. Seems you forgot to wrap the components in "<DatePicker />" `
});
export {
  Yn as DatePickerProvider,
  vn as DatePickerStylesProvider,
  On as useDatePicker,
  In as useDatePickerContext,
  xn as useDatePickerStyle
};
//# sourceMappingURL=DatePicker.context.es.js.map
